module.exports = __webpack_public_path__ + "img/signup.676d211f.jpg";